/**
 * @group Enums
 * 
 * @summary
 * <blockquote>Enumeration of resource types used throughout the application for categorization and permission management</blockquote>
 * 
 * @example
 * ```typescript
 * import { ResourceType } from './ResourceType';
 * 
 * // Check resource type
 * const type = ResourceType.PAGE;
 * 
 * // Use in permission checks
 * if (resource.type === ResourceType.DATABASE) {
 *   // Handle database operations
 * }
 * ```
 * 
 * Common values:
 * - `ResourceType.ACTION` - Server actions and API endpoints
 * - `ResourceType.DATABASE` - Database operations and data access
 * - `ResourceType.MODULE` - Feature modules and layouts
 * - `ResourceType.PAGE` - Individual pages and page components
 * - `ResourceType.ROUTE` - API routes and endpoints
 * - `ResourceType.UI` - UI components and client-side elements
 */
export enum ResourceType {
  /** Server actions and API endpoints */
  ACTION = 'action',
  /** Database operations and data access */
  DATABASE = 'database',
  /** Feature modules and layouts */
  MODULE = 'module',
  /** Individual pages and page components */
  PAGE = 'page',
  /** API routes and endpoints */
  ROUTE = 'route',
  /** UI components and client-side elements */
  UI = 'ui'
}
